import React, { useState, useEffect } from 'react';
import { Header, Dropdown } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { getBrands, getModelsForBrand, formatUrlPart } from '../services/api';

const TopSection = ({
  title = 'Customer Support Library',
  subtitle = 'Troubleshoot Issues Using Live Calls with the World\'s Largest Team of Certified RV Technicians',
  showLogo = true,
}) => {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState('');
  const [selectedModel, setSelectedModel] = useState('');
  const [isModelDropdownOpen, setIsModelDropdownOpen] = useState(false);
  const navigate = useNavigate();

  // Fetch brands when component mounts
  useEffect(() => {
    getBrands()
      .then(data => {
        const brandsArray = data.allBrands || [];
        const brandOptions = brandsArray.map(brand => ({
          key: brand._id,
          text: brand.originalBrand,
          value: brand._id
        }));
        setBrands(brandOptions);
      })
      .catch(err => console.error('Error fetching brands:', err));
  }, []);

  // Fetch models when a brand is selected and open the model dropdown
  useEffect(() => {
    if (selectedBrand) {
      getModelsForBrand(selectedBrand)
        .then(data => {
          const modelOptions = [
            {
              key: 'view-all',
              text: 'View All',
              value: 'view-all'
            },
            ...data.map(model => ({
              key: model._id,
              text: model._id,
              value: model._id
            }))
          ];
          setModels(modelOptions);
          setIsModelDropdownOpen(true);
        })
        .catch(err => console.error('Error fetching models:', err));
    } else {
      setModels([]);
      setSelectedModel('');
      setIsModelDropdownOpen(false);
    }
  }, [selectedBrand]);

  // Navigate automatically when a model is selected
  useEffect(() => {
    if (selectedBrand && selectedModel) {
      const formattedBrand = formatUrlPart(selectedBrand);
      if (selectedModel === 'view-all') {
        navigate(`/brand/${formattedBrand}`);
      } else {
        const formattedModel = formatUrlPart(selectedModel);
        navigate(`/brand/${formattedBrand}/model/${formattedModel}`);
      }
      setIsModelDropdownOpen(false);
    }
  }, [selectedModel, selectedBrand, navigate]);

  // Handle brand selection
  const handleBrandChange = (e, { value }) => {
    setSelectedBrand(value);
    setSelectedModel('');
  };

  // Handle model selection
  const handleModelChange = (e, { value }) => {
    setSelectedModel(value);
  };

  return (
    <div
      style={{
        backgroundColor: '#01274c',
        padding: '40px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
      }}
    >
      {showLogo && (
        <img
          src={`${process.env.PUBLIC_URL || ''}/bcrvlogo.png`}
          alt="Blue Compass RV"
          style={{
            maxWidth: '200px',
            width: '100%',
            marginBottom: '20px',
          }}
        />
      )}
      <Header
        as="h1"
        style={{
          fontSize: '3em',
          color: '#fff',
          marginBottom: '20px',
          textAlign: 'center',
        }}
      >
        {title}
        <Header.Subheader
          style={{
            fontSize: '.5em',
            color: '#fff',
            marginTop: '10px',
          }}
        >
          {subtitle}
        </Header.Subheader>
      </Header>
      <div
        className="dropdown-container"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '600px',
          width: '100%',
          gap: '10px',
        }}
      >
        <Dropdown
          placeholder="Select Brand"
          fluid
          search
          selection
          options={brands}
          value={selectedBrand}
          onChange={handleBrandChange}
          className="brand-dropdown"
        />
        <Dropdown
          placeholder="Select Model"
          fluid
          search
          selection
          options={models}
          value={selectedModel}
          onChange={handleModelChange}
          disabled={!selectedBrand}
          className="model-dropdown"
          open={isModelDropdownOpen}
          onOpen={() => setIsModelDropdownOpen(true)}
          onClose={() => setIsModelDropdownOpen(false)}
        />
      </div>
    </div>
  );
};

export default TopSection;